/**
 * Local SEO — Sholayar Dam, Valparai, Coimbatore hill station queries.
 * Override production URL: REACT_APP_SITE_URL=https://yoursite.com
 */
const siteUrl = (process.env.REACT_APP_SITE_URL || 'https://chansnest.in').replace(/\/$/, '');

export const seo = {
  siteUrl,
  /** Primary browser tab title — brand + high-intent local terms */
  pageTitle:
    "Chan's Nest Inn | Best Resort & Rooms in Sholayar Dam & Valparai — Book Hill Stay",
  /** ~155–300 chars: natural language + place names + intent */
  metaDescription:
    "Chan's Nest Inn is a top-rated resort and guest house in Sholayar Dam near Valparai, Tamil Nadu. Book the best rooms for families, couples, and groups — quiet stays, mountain views, warm hospitality, and easy access to Valparai tea estates, Sholayar forests, and Athirappilly-side trips. Compare resort and hotel options in Valparai; stay at Chan's Nest Inn on EB Road, Sholayar Dam (P.O).",
  /** Comma-separated — legacy meta keywords still used by some crawlers / tools */
  keywords: [
    "best resort in Sholayar",
    "best resort in Valparai",
    "Sholayar Dam resort",
    "Sholayar Dam rooms",
    "Valparai resort",
    "Valparai hotel",
    "Valparai guest house",
    "Valparai homestay",
    "Valparai accommodation",
    "rooms in Sholayar",
    "rooms in Valparai",
    "Sholayar Dam stay",
    "Sholayar Dam hotel",
    "tea estate stay Valparai",
    "hill station resort Valparai",
    "family rooms Valparai",
    "budget resort Valparai",
    "Chan's Nest Inn",
    "chansnest.in",
    "EB Road Sholayar Dam",
    "642125",
  ].join(', '),
  latitude: 10.3039899,
  longitude: 76.88021479999999,
};

export default seo;
